<template>
  <div class="site-seo-container">
    <div class="site-seo-content">
      <div class="site-seo-header">
        <h2>SEO设置</h2>
        <p>搜索引擎优化配置</p>
      </div>

      <el-form :model="form" label-width="120px">
        <el-form-item label="网站标题">
          <el-input v-model="form.siteTitle" placeholder="请输入网站标题"></el-input>
          <div class="help-text">网站在搜索引擎中显示的标题，建议不超过60个字符</div>
        </el-form-item>

        <el-form-item label="网站描述">
          <el-input
            v-model="form.siteDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入网站描述"
          ></el-input>
          <div class="help-text">网站在搜索引擎中显示的描述，建议不超过160个字符</div>
        </el-form-item>

        <el-form-item label="网站关键词">
          <el-input
            v-model="form.siteKeywords"
            placeholder="请输入网站关键词，多个关键词用逗号分隔"
          ></el-input>
          <div class="help-text">网站的核心关键词，建议不超过10个</div>
        </el-form-item>

        <el-form-item label="首页标题">
          <el-input v-model="form.homeTitle" placeholder="请输入首页标题"></el-input>
          <div class="help-text">首页在搜索引擎中显示的标题</div>
        </el-form-item>

        <el-form-item label="首页描述">
          <el-input
            v-model="form.homeDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入首页描述"
          ></el-input>
          <div class="help-text">首页在搜索引擎中显示的描述</div>
        </el-form-item>

        <el-form-item label="图片生成标题">
          <el-input v-model="form.imageTitle" placeholder="请输入图片生成页面标题"></el-input>
        </el-form-item>

        <el-form-item label="图片生成描述">
          <el-input
            v-model="form.imageDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入图片生成页面描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="视频生成标题">
          <el-input v-model="form.videoTitle" placeholder="请输入视频生成页面标题"></el-input>
        </el-form-item>

        <el-form-item label="视频生成描述">
          <el-input
            v-model="form.videoDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入视频生成页面描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="短剧生成标题">
          <el-input v-model="form.dramaTitle" placeholder="请输入短剧生成页面标题"></el-input>
        </el-form-item>

        <el-form-item label="短剧生成描述">
          <el-input
            v-model="form.dramaDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入短剧生成页面描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="OpenClaw标题">
          <el-input v-model="form.openclawTitle" placeholder="请输入OpenClaw页面标题"></el-input>
        </el-form-item>

        <el-form-item label="OpenClaw描述">
          <el-input
            v-model="form.openclawDescription"
            type="textarea"
            :rows="3"
            placeholder="请输入OpenClaw页面描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="网站地图">
          <el-switch v-model="form.sitemapEnabled" active-text="启用" inactive-text="禁用"></el-switch>
          <div class="help-text">启用后会自动生成网站地图XML文件</div>
        </el-form-item>

        <el-form-item label=" robots.txt ">
          <el-input
            v-model="form.robotsTxt"
            type="textarea"
            :rows="4"
            placeholder="请输入robots.txt内容"
          ></el-input>
          <div class="help-text">用于控制搜索引擎爬虫的抓取行为</div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="saveSettings" :loading="loading">保存设置</el-button>
          <el-button @click="resetForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'SiteSeo',
  data() {
    return {
      loading: false,
      form: {
        siteTitle: '',
        siteDescription: '',
        siteKeywords: '',
        homeTitle: '',
        homeDescription: '',
        imageTitle: '',
        imageDescription: '',
        videoTitle: '',
        videoDescription: '',
        dramaTitle: '',
        dramaDescription: '',
        openclawTitle: '',
        openclawDescription: '',
        sitemapEnabled: false,
        robotsTxt: ''
      }
    }
  },
  mounted() {
    this.initSettings()
  },
  methods: {
    initSettings() {
      this.loading = true
      axios.get('/admin/seo-setting')
        .then(response => {
          if (response.data.code === 200) {
            this.form = response.data.data
          }
        })
        .catch(() => {
          this.$message.error('获取设置失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveSettings() {
      this.loading = true
      axios.put('/admin/seo-setting', this.form)
        .then(() => {
          this.$message.success('设置保存成功')
        })
        .catch(() => {
          this.$message.error('保存设置失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetForm() {
      this.initSettings()
      this.$message.info('表单已重置')
    }
  }
}
</script>

<style scoped>
.site-seo-container {
  padding: 20px 0;
}

.site-seo-content {
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  color: #333;
}

.site-seo-header {
  margin-bottom: 30px;
}

.site-seo-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 8px;
}

.site-seo-header p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.help-text {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
}

.el-form-item {
  margin-bottom: 20px;
}

.el-button--primary {
  background: linear-gradient(135deg, #00e6ac, #00cc99);
  border: none;
  color: #000;
  font-weight: 600;
}

.el-button--primary:hover {
  background: linear-gradient(135deg, #00cc99, #00b386);
  color: #000;
}
</style>